var _path, _path2, _path3, _path4, _path5, _circle, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransit4On(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30762 15H24.6923V17.7383H5.30762V15Z",
    fill: "#196BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0776 9.58417H27.9233V12.0944H17.5391V2.50977H20.0776V9.58417Z",
    fill: "#196BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30762 20.25H24.6923V22.7601H5.30762V20.25Z",
    fill: "#196BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30762 25.2676H15V28.0058H5.30762V25.2676Z",
    fill: "#196BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.62305V23.1084C29.0876 23.2389 28.2126 23.4846 27.3916 23.834V10.6855L19.1377 2.56641H2.6084V31.4336H21.2041C21.0707 32.1018 21 32.7926 21 33.5C21 33.6676 21.0049 33.8343 21.0127 34H0V0H20.2178L30 9.62305Z",
    fill: "#196BFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 33.5,
    r: 8.5,
    fill: "#0ACF2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33.6289L31.5 39.2588V36.1289H28V31.1289H31.5V28L36 33.6289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit4On);
export default __webpack_public_path__ + "static/media/transit4On.1138253622f250f4b2f978e2451a4a00.svg";
export { ForwardRef as ReactComponent };